
import { CRMSearchFilter } from "./CRMSearchFilter";
import { CRMDateFilter } from "./CRMDateFilter";
import { CRMFilterPanel } from "./CRMFilterPanel";
import { Filters } from "./types";

interface CRMFiltersProps {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  showFilters: boolean;
  crmDataLength: number;
  filteredDataLength: number;
  handleSearchChange: (value: string) => void;
  handleStartDateChange: (date: Date | undefined) => void;
  handleEndDateChange: (date: Date | undefined) => void;
  handleDateFieldChange: (field: string) => void;
}

export const CRMFilters = ({
  filters,
  setFilters,
  showFilters,
  crmDataLength,
  filteredDataLength,
  handleSearchChange,
  handleStartDateChange,
  handleEndDateChange,
  handleDateFieldChange,
}: CRMFiltersProps) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row gap-4 justify-between">
        <CRMSearchFilter 
          searchTerm={filters.searchTerm}
          onSearchChange={handleSearchChange}
        />
        <CRMDateFilter
          startDate={filters.startDate}
          endDate={filters.endDate}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          dateField={filters.dateField}
          onDateFieldChange={handleDateFieldChange}
        />
      </div>
      
      {showFilters && (
        <CRMFilterPanel 
          filters={filters}
          setFilters={setFilters}
          totalRecords={crmDataLength}
          filteredRecords={filteredDataLength}
        />
      )}
    </div>
  );
};
